import * as angular from 'angular';

import { TransactionFactory } from './transaction.factory';

export const transactionModelModule = angular.module('go.models.transaction', [])
	.factory(TransactionFactory.NG1_INJECTION_NAME, TransactionFactory)
	.name;
